export default "mutation refreshAccess($refreshToken: String!) {\n  refreshAccess(refreshToken: $refreshToken) {\n    token\n    refreshToken\n  }\n}";